import { apiClient } from '@/utils/api-client'

const ULID_PATTERN = /^[0-9A-HJKMNP-TV-Z]{26}$/i

const VALID_EVENT_KEYS = new Set([
    'account_created',
    'email_verified',
    'first_login',
    'sdk_connected',
    'flag_created',
    'teammate_invited',
    'billing_added',
    'survey_completed',
])

function assertUlid(value) {
    if (!ULID_PATTERN.test(value)) {
        throw new Error(`Invalid ULID: ${value}`)
    }
}

function assertEventKey(value) {
    if (!VALID_EVENT_KEYS.has(value)) {
        throw new Error(`Unknown onboarding event key: ${value}`)
    }
}

class OnboardingService {
    async status(accountUlid) {
        assertUlid(accountUlid)
        return await apiClient
            .get(`/account/${accountUlid}/onboarding`)
            .then((response) => response.data)
    }

    async markComplete(accountUlid, eventKey) {
        assertUlid(accountUlid)
        assertEventKey(eventKey)
        return await apiClient
            .post(
                `/account/${accountUlid}/onboarding/${eventKey}/complete`,
                null
            )
            .then((response) => response.data)
    }
}

export default new OnboardingService()
